<template>
  <el-dialog
    :title="$t('integralShopRule.add')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="closeDialog"
  >
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      label-width="120px"
    >
      <el-form-item
        :label="$t('integralShopRule.ruleName')"
        prop="ruleName"
      >
        <el-input
          v-model="formData.ruleName"
          :placeholder="$t('integralShopRule.ruleNamePlaceholder')"
        />
      </el-form-item>
      <el-form-item
        :label="$t('integralShopRule.money')"
        prop="money"
      >
        <el-input
          v-model="formData.money"
          :placeholder="$t('integralShopRule.moneyPlaceholder')"
        />
      </el-form-item>
      <el-form-item
        :label="$t('integralShopRule.amount')"
        prop="amount"
      >
        <el-input
          v-model="formData.amount"
          :placeholder="$t('integralShopRule.amountPlaceholder')"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="submitForm">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveIntegralShopRule } from '@/api/shop/integralShopRuleApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AddIntegralShopRule',
  data() {
    return {
      dialogVisible: false,
      formData: {
        ruleName: '',
        money: '',
        amount: '',
        shopId: ''
      },
      rules: {
        ruleName: [
          { required: true, message: this.$t('integralShopRule.ruleNameRequired'), trigger: 'blur' },
          { max: 128, message: this.$t('integralShopRule.ruleNameMaxLength'), trigger: 'blur' }
        ],
        money: [
          { required: true, message: this.$t('integralShopRule.moneyRequired'), trigger: 'blur' },
          { max: 30, message: this.$t('integralShopRule.moneyMaxLength'), trigger: 'blur' }
        ],
        amount: [
          { required: true, message: this.$t('integralShopRule.amountRequired'), trigger: 'blur' },
          { max: 30, message: this.$t('integralShopRule.amountMaxLength'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.resetForm()
    },
    closeDialog() {
      this.dialogVisible = false
    },
    resetForm() {
      this.formData = {
        ruleName: '',
        money: '',
        amount: '',
        shopId: getShopId()
      }
      this.$refs.form && this.$refs.form.resetFields()
    },
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            await saveIntegralShopRule(this.formData)
            this.$message.success(this.$t('integralShopRule.saveSuccess'))
            this.closeDialog()
            this.$emit('refresh')
          } catch (error) {
            console.error('保存积分规则失败:', error)
          }
        }
      })
    }
  }
}
</script>